module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady && _vm.footerReady) ? _c('footer', {
    staticClass: "main-footer"
  }, [(!this.$root.smallFooter) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row no-margin new-footer"
  }, [_c('div', {
    staticClass: "col-l-12 col-m-12 col-s-12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.footer.general_enquiries.title))]), _vm._v(" "), _c('div', {
    staticClass: "row no-margin"
  })]), _vm._v(" "), _vm._l((_vm.footer.general_enquiries.elements), function(element, i) {
    return _c('div', {
      key: i,
      class: [
        _vm.footer.general_enquiries.elements.length == 2 ?
        'col-l-4 col-m-4' :
        'col-l-3 col-m-3',
        'col-s-12 contact' ]
    }, [_c('div', {
      staticClass: "box box--white"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(element.title))]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(element.name))]), _vm._v(" "), _c('p', {
      staticClass: "footer-email"
    }, [_c('a', {
      attrs: {
        "href": ['mailto:' + element.email]
      }
    }, [_vm._v(_vm._s(element.email))])]), _vm._v(" "), _c('p', {
      staticClass: "number"
    }, [_c('a', {
      attrs: {
        "href": ['tel:' + element.number]
      }
    }, [_vm._v(_vm._s(element.number))])])])])
  }), _vm._v(" "), (_vm.footer.crisis_support.title) ? _c('div', {
    class: [
      _vm.footer.general_enquiries.elements.length == 2 ?
      'col-l-4 col-m-4' :
      'col-l-3 col-m-3',
      'col-s-12 crisis-contact' ]
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.footer.crisis_support.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.footer.crisis_support.text))]), _vm._v(" "), _c('p', {
    staticClass: "footer-email"
  }, [(_vm.footer.crisis_support.email) ? _c('a', {
    staticClass: "footer-email",
    attrs: {
      "href": ['mailto:' + _vm.footer.crisis_support.email]
    }
  }, [_vm._v(_vm._s(_vm.footer.crisis_support.email))]) : _vm._e()]), _vm._v(" "), (_vm.footer.crisis_support.number) ? _c('p', [_c('a', {
    attrs: {
      "href": ['tel:' + _vm.footer.crisis_support.number]
    }
  }, [_vm._v(_vm._s(_vm.footer.crisis_support.number))])]) : _vm._e(), _vm._v(" "), (_vm.footer.crisis_support.number2) ? _c('p', [_c('a', {
    attrs: {
      "href": ['tel:' + _vm.footer.crisis_support.number2]
    }
  }, [_vm._v(_vm._s(_vm.footer.crisis_support.number2))])]) : _vm._e()])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row no-margin new-footer"
  }, [_c('div', {
    staticClass: "col-l-12 col-m-12 col-s-12"
  }, [_c('div', {
    staticClass: "socials"
  }, [_c('span', {
    staticClass: "social-container"
  }, _vm._l((_vm.footer.socials), function(social, i) {
    return _c('a', {
      key: i,
      staticClass: "icon",
      attrs: {
        "href": social.link,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(social.icon)
      }
    })
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row no-margin new-footer"
  }, [_c('div', {
    staticClass: "col-l-5 col-m-5 col-s-12 order-s-2"
  }, [_c('div', {
    staticClass: "footer-text footer-copyright"
  }, [_c('ul', [_c('li', [_vm._v(_vm._s(_vm.footer.copyright))]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "modern-slavery pl-10",
    attrs: {
      "href": _vm.footer.modern_slavery_statement
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.footer.modern_slavery_statement_label))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-l-7 col-m-7 col-s-12 order-s-1"
  }, [_c('div', {
    staticClass: "footer-text"
  }, [_c('ul', _vm._l((_vm.menus), function(menu, index) {
    return _c('li', {
      key: index,
      attrs: {
        "active-class": "active"
      }
    }, [_c('a', {
      attrs: {
        "href": menu.url
      }
    }, [_vm._v(_vm._s(menu.title))])])
  }), 0)])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1a89f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainFooter.vue
// module id = 358
// module chunks = 0